export function omitProperties(obj, keys)
{

    for (let key of keys) {
        if (!Object.prototype.hasOwnProperty.call(obj, key)) {
            console.warn(`Key "${key}" does not exist in the object: ${obj}`);

            return new Error(`Key "${key}" does not exist in the object: ${obj}`);
        }
    }

    return Object.fromEntries(
        Object.entries(obj).filter(([key]) => !keys.includes(key))
    );
}